var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEkataGrayLogo = function SvgEkataGrayLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18478 2.86982V0.864094C9.18478 0.66301 9.03488 0.5 8.84996 0.5H1.14927C0.964354 0.5 0.814453 0.66301 0.814453 0.864094V11.1359C0.814453 11.337 0.964354 11.5 1.14927 11.5H8.84997C9.03488 11.5 9.18478 11.337 9.18478 11.1359V9.22667C9.18478 9.02558 9.03488 8.86257 8.84997 8.86257H3.84078C3.65587 8.86257 3.50597 8.69956 3.50597 8.49848V3.59801C3.50597 3.39693 3.65587 3.23392 3.84078 3.23392H8.84997C9.03488 3.23392 9.18478 3.07091 9.18478 2.86982Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 6.7302V5.23909C4.33398 5.03801 4.48389 4.875 4.6688 4.875H7.78504C7.96996 4.875 8.11986 5.03801 8.11986 5.23909V6.73021C8.11986 6.93129 7.96996 7.0943 7.78504 7.0943H4.6688C4.48389 7.0943 4.33398 6.93129 4.33398 6.7302Z",
    fill: "#595959"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEkataGrayLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ekata-gray-logo.faa678770070462058afae046fa0d424.svg";